import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { colors, font, maxWidth } from "../styles/theme";
import { useRequestModal } from "../components/ModalProvider";
import ServicesAccordion from "../components/ServicesAccordion";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";

// Страница «Услуги подробно»: назад → заголовок → аккордеон → CTA (попап) → форма.
export default function ServicesPage() {
  const { openRequest } = useRequestModal();
  const [params] = useSearchParams();
  const initial = params.get("svc");

  // Наверх — только если конкретная услуга не выбрана (иначе аккордеон сам доскроллит к ней).
  useEffect(() => {
    if (!initial) window.scrollTo(0, 0);
  }, [initial]);

  return (
    <main className="page-enter" style={{ background: colors.bgLight, minHeight: "100vh" }}>
      <div style={{ maxWidth, margin: "0 auto", padding: "26px 22px 10px" }}>
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            textDecoration: "none",
            fontFamily: font.display,
            fontWeight: 600,
            fontSize: 13,
            letterSpacing: ".06em",
            textTransform: "uppercase",
            color: colors.ink,
            padding: "10px 16px 10px 12px",
            background: "#fff",
            border: "1px solid #e6e9ee",
            borderRadius: 10,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = colors.red;
            e.currentTarget.style.borderColor = colors.red;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = colors.ink;
            e.currentTarget.style.borderColor = "#e6e9ee";
          }}
        >
          <ArrowLeft size={18} /> На главную
        </Link>
      </div>

      <header style={{ maxWidth, margin: "0 auto", padding: "20px 22px 8px" }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            fontFamily: font.display,
            fontWeight: 600,
            fontSize: 12,
            letterSpacing: ".16em",
            textTransform: "uppercase",
            color: colors.red,
          }}
        >
          <span style={{ width: 26, height: 2, background: colors.red, display: "inline-block" }} />
          Что входит в работу
        </span>
        <h1
          style={{
            fontFamily: font.display,
            fontWeight: 700,
            fontSize: "clamp(2.2rem,5vw,3.8rem)",
            lineHeight: 1.02,
            textTransform: "uppercase",
            margin: "14px 0 0",
            color: colors.ink,
          }}
        >
          Услуги <span style={{ color: colors.red }}>ВК-КЛИМАТ</span>
        </h1>
        <p style={{ maxWidth: 720, fontSize: 17, lineHeight: 1.6, color: colors.text, margin: "18px 0 0" }}>
          Выполняем полный цикл работ по климату — от инженерного расчёта и проекта до монтажа, пусконаладки и
          сервисного обслуживания. Нажмите на услугу, чтобы узнать, что в неё входит.
        </p>
      </header>

      <div style={{ maxWidth, margin: "0 auto", padding: "30px 22px 8px" }}>
        <ServicesAccordion initial={initial} />
      </div>

      {/* CTA — открывает тот же попап «Заявка», что и кнопка в шапке */}
      <div style={{ maxWidth, margin: "0 auto", padding: "26px 22px 60px" }}>
        <button
          onClick={openRequest}
          style={{
            width: "100%",
            background: colors.red,
            color: "#fff",
            border: "none",
            fontFamily: font.display,
            fontWeight: 700,
            fontSize: "clamp(15px,2vw,19px)",
            letterSpacing: ".05em",
            textTransform: "uppercase",
            padding: "22px",
            borderRadius: 14,
            cursor: "pointer",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = colors.redDark)}
          onMouseLeave={(e) => (e.currentTarget.style.background = colors.red)}
        >
          Получить расчёт стоимости
        </button>
      </div>

      <LeadForm />
      <Footer />
    </main>
  );
}
